import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { STATUS_VALUE_OPTIONS } from './optionValues';

export const PRIORITY_OPTIONS = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
];

export const KEY_COMPETITORS_PRIORITY_OPTIONS = [
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Middle' },
  { value: 'Low', label: 'Low' },
];

export const TERMS_OPTIONS = [
  { value: 'longTerm', label: 'Long-term' },
  { value: 'shortTerm', label: 'Short-term' },
];

export const LIFE_CYCLE_STAGES_OPTIONS = [
  { label: 'Idea', value: 'Idea' },
  { label: 'R&D', value: 'R&D' },
  { label: 'Growth', value: 'Growth' },
  { label: 'Maturity', value: 'Maturity' },
];

export const PROJECT_STATUS_OPTIONS = [
  { value: 'Idea Assessment', label: 'Idea Assessment' },
  { value: 'Research and Development', label: 'Research and Development' },
  { value: 'Evaluation and Selection', label: 'Evaluation and Selection' },
  { value: 'Financing', label: 'Financing' },
  { value: 'Implementation', label: 'Implementation' },
  { value: 'Operation and Management', label: 'Operation and Management' },
];

export const FUNDING_DIRECTIONS_OPTIONS = [
  { label: 'Research and Development (R&D)', value: 'Research and Development (R&D)' },
  { label: 'Marketing and Sales', value: 'Marketing and Sales' },
  { label: 'Working Capital', value: 'Working Capital' },
  { label: 'Construction of Buildings and Facilities', value: 'Construction of Buildings and Facilities' },
  { label: 'Purchase of Equipment', value: 'Purchase of Equipment' },
];

export const STATUS_OPTIONS = [
  { value: STATUS_VALUE_OPTIONS.DONE, label: 'Done' },
  { value: STATUS_VALUE_OPTIONS.IN_PROGRESS, label: 'In Progress' },
  { value: STATUS_VALUE_OPTIONS.TO_DO, label: 'To Do' },
];

export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Gender-Neutral', label: 'Gender-Neutral' },
];

export const PRODUCT_SERVICE_OPTIONS = [
  { value: 'Product/Service', label: 'Product/Service' },
  { value: 'Region', label: 'Region' },
  { value: 'Market Segment', label: 'Market Segment' },
];

export const CONSUMER_OPTIONS = [
  { value: 'Product', label: 'Product' },
  { value: 'Service', label: 'Service' },
  { value: 'Consumer', label: 'Consumer' },
  { value: 'Producer', label: 'Producer' },
  { value: 'Other Market Segment', label: 'Other Market Segment' },
];

export const UNITS_VALUES = {
  VOLUME_IN: 'Volume in',
  CURRENCY: 'Currency',
} as const;

export const PREMISE_TERMS_OF_USE_OPTIONS = [
  { value: 'Ownership', label: 'Ownership' },
  { value: 'Renting', label: 'Renting' },
  { value: 'Leasing', label: 'Leasing' },
  { value: 'Shared Ownership', label: 'Shared Ownership' },
];

export const DELIVERY_TERMS_OPTIONS = [
  { value: 'Prepayment', label: 'Prepayment' },
  { value: 'Upon delivery', label: 'Upon delivery' },
  { value: 'Deferred payment', label: 'Deferred payment' },
];

export const RISKS_OPTIONS = [
  { value: 'marketRisks', label: 'Market Risks' },
  { value: 'operationalRisks', label: 'Operational Risks' },
  { value: 'financialRisks', label: 'Financial Risks' },
  { value: 'legalAndRegulatoryRisks', label: 'Legal and Regulatory Risks' },
  { value: 'technologicalRisks', label: 'Technological Risks' },
  { value: 'humanResourceRisks', label: 'Human Resource Risks' },
  { value: 'environmentalRisks', label: 'Environmental Risks' },
  { value: 'other', label: 'Other' },
];

export const ONE_PAGE_OPTIONS = [
  { label: 'Short', value: BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT },
  { label: 'Extended', value: BUSINESS_PLAN_TYPES.ONE_PAGE },
];
